import React from 'react';
import s from './s.module.less';
import AccessStore from 'store/Access/permission';
import { ETextVisitProviderApproveStatus } from 'types/textVisitCase';
import { getUrlParam } from 'utils/common';
import { Button, message, Tabs } from 'antd';
import { PATH } from 'constants/path';
import CaseTab from './components/CaseTab';
import CasesTable from '../TextVisitCases/components/CasesTable';

const TextVisitProviderCasePage = () => {
    const [getAccessStore] = AccessStore.useStore();
    const [providerId, setProviderId] = React.useState<number>();
    const [providerName, setProviderName] = React.useState<string>();
    const [providerStatus, setProviderStatus] = React.useState<ETextVisitProviderApproveStatus>();
    const [key, setKey] = React.useState<'progress' | 'active' | 'closed'>('progress');
    const [progressCount, setProgressCount] = React.useState<number>();
    const [activeCount, setActiveCount] = React.useState<number>();
    const [closedCount, setClosedCount] = React.useState<number>();
    const access = getAccessStore('data');

    React.useEffect(() => {
        const _providerId = getUrlParam('pid');
        const _providerName = getUrlParam('name');
        const _providerStatus = getUrlParam('status');
        try {
            setProviderId(Number(_providerId));
            setProviderName(decodeURIComponent(_providerName || ''));
            setProviderStatus(_providerStatus as ETextVisitProviderApproveStatus);
        } catch (e) {
            console.error(e);
            message.error('Invalid URL parameters');
        }
    }, []);

    const statusMap: Record<string, string> = {
        [ETextVisitProviderApproveStatus.PENDING]: 'Pending approval',
        [ETextVisitProviderApproveStatus.APPROVED]: 'Approved',
        [ETextVisitProviderApproveStatus.PAUSE]: 'Paused',
        [ETextVisitProviderApproveStatus.REJECT]: 'Rejected',
    };
    const displayStatus = providerStatus ? (statusMap[providerStatus] || providerStatus) : '';

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <div className={s.left}>
                    <h3>Text visit cases for {providerName}</h3>
                    <span
                        className={`${s.statusBadge} ${s[displayStatus.toLowerCase().replace(/\s+/g, '')]}`}
                    >
                        {displayStatus}
                    </span>
                </div>
                <div className={s.right}>
                    <Button
                        className={s.btn}
                        onClick={() => {
                            const url =
                                `/operation/${PATH.PPA_PROVIDER_DETAIL}/-1/${providerId}?id=${providerId}&providerId=${providerId
                                }&slug=${encodeURIComponent(
                                    providerName || '',
                                )}`;
                            window.open(url, '_blank');
                        }}
                        size="large"
                    >View provider profile
                    </Button>
                </div>
            </div>
            <div className={s.content}>
                <CasesTable
                    from="providerCase"
                    assignedProviderId={providerId}
                />
                {/* <Tabs
                    activeKey={key}
                    onChange={(_key) => setKey(_key as 'progress' | 'active' | 'closed')}
                >
                    <Tabs.TabPane key="progress" tab={progressCount !== undefined ? `In-progress (${progressCount})` : 'In-progress'} forceRender>
                        <CaseTab
                            onLoaded={(count) => setProgressCount(count)}
                            assignedProviderId={providerId}
                            status={['ACTIVE', 'UNASSIGNED']}
                            treatmentSubmitted={false}
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="active" tab={activeCount !== undefined ? `Active (${activeCount})` : 'Active'} forceRender>
                        <CaseTab
                            onLoaded={(count) => setActiveCount(count)}
                            assignedProviderId={providerId}
                            status={['ACTIVE', 'UNASSIGNED']}
                            treatmentSubmitted
                        />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="closed" tab={closedCount !== undefined ? `Closed (${closedCount})` : 'Closed'} forceRender>
                        <CaseTab
                            onLoaded={(count) => setClosedCount(count)}
                            assignedProviderId={providerId}
                            status={['CLOSED']}
                            treatmentSubmitted={false}
                        />
                    </Tabs.TabPane>
                </Tabs> */}
            </div>
        </div>
    );
};

export default TextVisitProviderCasePage;
